import { Event, Paid, Summarize } from '@mui/icons-material';
import { Box, Paper, Tab, Tabs } from '@mui/material';
import { useState } from 'react';
import PayrollAdjustmentsPage from './PayrollAdjustmentsPage';
import PayrollHolidaysPage from './PayrollHolidaysPage';
import PayrollSummaryPage from './PayrollSummaryPage';

function PayrollView({ storeId }) {
  const [activeTab, setActiveTab] = useState(0);

  const tabs = [
    {
      label: 'Feriados',
      icon: <Event />,
      component: <PayrollHolidaysPage storeId={storeId} />,
    },
    {
      label: 'Ajustes',
      icon: <Paid />,
      component: <PayrollAdjustmentsPage storeId={storeId} />,
    },
    {
      label: 'Resumen por Cajero',
      icon: <Summarize />,
      component: <PayrollSummaryPage storeId={storeId} />,
    },
  ];

  return (
    <Box sx={{ p: { xs: 1.5, md: 3 } }}>
      <Paper
        elevation={0}
        sx={{
          mb: 2,
          borderRadius: 3,
          overflow: 'hidden',
          border: '1px solid',
          borderColor: 'divider',
        }}
      >
        <Tabs
          value={activeTab}
          onChange={(_, value) => setActiveTab(value)}
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            '& .MuiTab-root': {
              py: 1.5,
              px: 2,
              textTransform: 'none',
              fontWeight: 600,
            },
          }}
        >
          {tabs.map((tab, idx) => (
            <Tab
              key={idx}
              icon={tab.icon}
              iconPosition="start"
              label={tab.label}
              sx={{
                '&.Mui-selected': {
                  bgcolor: 'primary.main',
                  color: 'white !important',
                  '& .MuiSvgIcon-root': { color: 'white' },
                },
              }}
            />
          ))}
        </Tabs>
      </Paper>

      <Box>{tabs[activeTab].component}</Box>
    </Box>
  );
}

export default PayrollView;
